// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3gi6K","info":"UpdateTermsInfo_info__3R6Rt"};